import { render, staticRenderFns } from "./SfSidebar.vue?vue&type=template&id=f616ae82&"
import script from "./SfSidebar.vue?vue&type=script&lang=js&"
export * from "./SfSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SfSidebar.vue?vue&type=style&index=0&id=f616ae82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports